import { createFileRoute } from '@tanstack/react-router';
import { EventCategoriesPage } from '@pages/event-categories';

/** Event-Kategorien-Verwaltungsseite (/event-categories) */
export const Route = createFileRoute('/_authenticated/event-categories')({
  component: EventCategoriesPage,
});
